import { Button } from "antd";
import React from "react";
import { useSelector } from "react-redux";

export const Hide = ({ handleVerTodo }) => {
    const {verTodo} = useSelector(state => state.reportesReducer);
  return <Button onClick={()=> handleVerTodo(!verTodo)}> {verTodo ? "Ocultar" : "Mostrar"}</Button>;
};
